document.addEventListener( 'DOMContentLoaded', () => {
  const notificationText = document.querySelector( '.notification-text' );
  let isTickerEnabled = false;
  
  const debounce = ( fn, delay ) => {
    let timeoutId;
    return ( ...args ) => {
      clearTimeout( timeoutId );
      timeoutId = setTimeout( () => fn.apply( this, args ), delay );
    };
  };
  
  const enableTicker = () => {
    if ( !notificationText || window.innerWidth < 1200 || isTickerEnabled ) {
      return;
    }
          
    try {
      const content = notificationText.textContent.trim();
          
      const measure = document.createElement( 'p' );
      measure.style.cssText = `
              visibility: hidden;
              position: absolute;
              white-space: nowrap;
              font-size: ${window.getComputedStyle( notificationText ).fontSize};
              font-family: ${window.getComputedStyle( notificationText ).fontFamily};
          `;
      measure.textContent = content;
      document.body.appendChild( measure );
          
      const textWidth = measure.offsetWidth;
      const containerWidth = notificationText.offsetWidth;
          
      document.body.removeChild( measure );
          
      if ( textWidth <= containerWidth ) {
        isTickerEnabled = false;
        return;
      }
  
      const wrapper = document.createElement( 'div' );
      wrapper.classList.add( 'ticker-wrapper' );
  
      const p1 = document.createElement( 'p' );
      const p2 = document.createElement( 'p' );
      p1.classList.add( 'ticker-slide' );
      p2.classList.add( 'ticker-slide' );
      p1.textContent = content;
      p2.textContent = content;
  
      wrapper.appendChild( p1 );
      wrapper.appendChild( p2 );
  
      notificationText.innerHTML = '';
      notificationText.appendChild( wrapper );
  
      requestAnimationFrame( () => {
        const slideWidth = p1.offsetWidth;
        if ( slideWidth > 0 ) {
          wrapper.style.width = `${slideWidth * 2}px`;
        }
        isTickerEnabled = true;
      } );
    } catch ( error ) {
      console.error( 'Error in enableTicker:', error );
      isTickerEnabled = false;
    }
  };
  
  const disableTicker = () => {
    if ( !notificationText ) return;
    
    try {
      const wrappers = notificationText.querySelectorAll( '.ticker-wrapper' );
      if ( wrappers.length > 0 ) {
        const originalContent = wrappers[0].querySelector( 'p' )?.innerHTML || '';
          
        wrappers.forEach( wrapper => wrapper.remove() );
          
        notificationText.innerHTML = originalContent;
      }
        
      isTickerEnabled = false;
    } catch ( error ) {
      console.error( 'Error in disableTicker:', error );
    }
  };
    
  const handleResize = debounce( () => {
    if ( window.innerWidth >= 1200 ) {
      disableTicker();
      enableTicker();
    } else {
      disableTicker();
    }
  }, 250 );
  
  handleResize();
  window.addEventListener( 'resize', handleResize );
  
  window.addEventListener( 'beforeunload', () => {
    window.removeEventListener( 'resize', handleResize );
  } );
} );
